namespace JupitersChoice {
    export class ShowReelsCmd {

        @inject('LayerManager') _layerManager: Sapphire.LayerManager;

        execute(): void {
            this._layerManager.setVisibility('Reels', true);
        }
    }
}